import { NuqsAdapter } from 'nuqs/adapters/react' // TODO: Remove nuqs after upgrade react router to 6+
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { MUITheme } from 'shared/integrations/mui'

import './shared/polyfills'
import { App, init } from './components/app'
import store from './redux/store'

init()

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
	<BrowserRouter>
		<Provider store={store}>
			<MUITheme>
				<NuqsAdapter>
					<App />
				</NuqsAdapter>
			</MUITheme>
		</Provider>
	</BrowserRouter>
)
